import React from 'react'
import { isRichTextEmpty } from '../../../lib/richText'
import uniq from 'lodash/uniq'
import withStyles from 'constructicon/with-styles'
import styles from './styles'
import isBadgeAchieved from './isBadgeAchieved'

import Badge from './Badge'
import Grid from 'constructicon/grid'
import GridColumn from 'constructicon/grid-column'
import Heading from 'constructicon/heading'
import RichText from '../../ui/RichText'
import Section from '../../ui/Section'

const Badges = ({
  alignment,
  background,
  customSupporterPage,
  foreground,
  fundraisingPage,
  items,
  spacing,
  styles,
  title
}) => {
  const { fitness } = customSupporterPage
  const categories = uniq(items.map(item => item.category))

  return (
    <Section
      alignment={alignment}
      background={background}
      foreground={foreground}
      spacing={spacing}
    >
      {!isRichTextEmpty(title) && (
        <RichText styles={styles.title}>
          {title}
        </RichText>
      )}
      {categories.map((category, x) => {
        const badges = items.filter(item => item.category === category)

        return (
          <div key={x}>
            {category && (
              <Heading size={1} spacing={{ t: 1, b: 0.5 }}>
                {category}
              </Heading>
            )}
            <Grid
              justify='flex-start'
              spacing={0.5}>
              {badges.map((badge, y) => (
                <GridColumn
                  key={y}
                  xs={6}
                  sm={4}
                  lg={3}>
                  <Badge
                    achieved={isBadgeAchieved(badge, fundraisingPage, fitness.goalUom, items)}
                    badge={badge}
                    fundraisingPage={fundraisingPage}
                  />
                </GridColumn>
              ))}
            </Grid>
          </div>
        )
      })}
    </Section>
  )
}

export default withStyles(styles)(Badges)
